import makeStyles from '@material-ui/styles/makeStyles';
 
const style = makeStyles((theme) => ({
    dialog: {
        '& h2': {            
            textAlign: 'center',
        },
        '& .MuiTypography-root': {
            color: '#000',
            '& button': {
                '& svg': {
                    fill: '#000',
                }
            }
        },
        '& .MuiPaper-root': {
            background: '#000',
        },
        '& .MuiDialog-paper': {
            minHeight: 100,
            margin: 0,
            maxWidth: 700,
            boxShadow: 'none',
            borderRadius: 8,
            width: 700,
            boxSizing: 'border-box',
            padding: 20,
            '@media (max-width: 767px)': {
                width: '95%',
            },
            '& div[class*="-formControl-"]': {
                margin: '0',
            },
        },
        '& .MuiDialogTitle-root': {
            padding: '5px 0 20px',
        },
    },
    dialogButtons: {
        margin: '40px 0 30px',
        justifyContent: 'flex-start',
        padding: 0,
    },
}));

export default style;
